import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./styles";

const AlertModal = ({
  open,
  onClose,
  onActionClick,
  title,
  description,
  actionBtnText,
  actionLoader,
  children,
}) => {
  const {
    dialogPaper,
    headerBox,
    dialogTitle,
    closeIcon,
    dialogContent,
    descriptionStyle,
    dialogActions,
    actionButton,
    loader,
  } = styles;
  return (
    <Dialog
      open={open}
      PaperProps={{ sx: dialogPaper }}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <Box sx={headerBox}>
        <DialogTitle sx={dialogTitle}>{title}</DialogTitle>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" sx={closeIcon} />
        </IconButton>
      </Box>

      <DialogContent sx={dialogContent}>
        {children ? (
          children
        ) : (
          <Typography sx={descriptionStyle}>{description}</Typography>
        )}
      </DialogContent>

      <DialogActions sx={dialogActions}>
        <Button
          variant="contained"
          onClick={onActionClick}
          sx={actionButton}
          disabled={actionLoader}
        >
          {actionBtnText}
          {actionLoader && <CircularProgress size={20} sx={loader} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertModal;
